// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1k-qN","modalForm":"UpgradeEpcsModal_modalForm__32CgB","modalFooter":"UpgradeEpcsModal_modalFooter__2lYU4"};